<span>
  <img class="relation-icon" [src]="urlSource" alt="{{ translationText | translate }}" />
  {{ translationText | translate }}
</span>
